
import { createSelector } from '@ngrx/store';
import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';
import { entityMaquinaMovilAdapter, EntityMaquinaMovilState } from './entity-maquinas-moviles.state';
import { selectCurrentEmpresa } from '../../empresas/entity-mis-empresas/entity-current-empresa.selectors';

const { selectEntities, selectAll } = entityMaquinaMovilAdapter.getSelectors();

export const getError = (state: EntityMaquinaMovilState): any => state.error;

export const getIsLoading = (state: EntityMaquinaMovilState): boolean =>
  state.isLoading;

export const getHasAddedSuccess = (state: EntityMaquinaMovilState): boolean =>
  state.hasAddedSuccess;

export const selectEntityMaquinaMovilState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.maquinaMovil
);

export const selectAllEntityMaquinaMovil = createSelector(selectEntityMaquinaMovilState, selectAll);
export const selectEntityMaquinaMovil = createSelector(
  selectEntityMaquinaMovilState,
  selectEntities
);

export const selectMaquinaMovilError = createSelector(
  selectEntityMaquinaMovilState,
  getError
);

export const selectMaquinaMovilIsLoading = createSelector(
  selectEntityMaquinaMovilState,
  getIsLoading
);

export const selectMaquinaMovilById = (selectMaquinaMovilId: number) => createSelector(
  selectAllEntityMaquinaMovil,
  (maquinaMovil) =>
    maquinaMovil.find((sp) => sp.id == selectMaquinaMovilId)
);

export const selectMaquinaMovilAddedSuccess = createSelector(
  selectEntityMaquinaMovilState,
  getHasAddedSuccess
);

export const selectAllMaquinaMovilCurrentEmpresa = createSelector(
  selectAllEntityMaquinaMovil,
  selectCurrentEmpresa,
  (maquinaMovil, currentEmpresa) => {
    if (maquinaMovil && currentEmpresa) {
      return maquinaMovil.filter((sp) => sp.entidad_productiva_id == currentEmpresa.id)
    } else {
      return []
    }
  }
);
